<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button></ion-back-button>
        </ion-buttons>
        <ion-title>Campaign Format Selector</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <!-- Format Selection View -->
    @if (!showPreview) {
        <ion-list-header color="secondary">
            <ion-label>Select Display Format</ion-label>
        </ion-list-header>

        <ion-list>
            <ion-item button (click)="onFormatSelect('format1')" [detail]="true">
                <ion-icon name="list-outline" slot="start"></ion-icon>
                <ion-label>
                    <h2>Format 1 - Classic List</h2>
                    <p>Traditional list view with title and details</p>
                </ion-label>
                @if (selectedFormat === 'format1') {
                    <ion-icon name="checkmark-circle" color="primary" slot="end"></ion-icon>
                }
            </ion-item>

            <ion-item button (click)="onFormatSelect('format2')" [detail]="true">
                <ion-icon name="grid-outline" slot="start"></ion-icon>
                <ion-label>
                    <h2>Format 2 - Card Grid</h2>
                    <p>Modern card-based layout</p>
                </ion-label>
                @if (selectedFormat === 'format2') {
                    <ion-icon name="checkmark-circle" color="primary" slot="end"></ion-icon>
                }
            </ion-item>
        </ion-list>

        <div class="ion-padding">
            <ion-button 
                expand="block" 
                [disabled]="!selectedFormat"
                (click)="onShowPreview()">
                Show Preview
            </ion-button>
        </div>
    }

    <!-- Preview View with Selected Format -->
    @if (showPreview && selectedFormat) {
        <ion-toolbar>
            <ion-buttons slot="start">
                <ion-button (click)="onBackToSelection()">
                    <ion-icon name="arrow-back" slot="start"></ion-icon>
                    Change Format
                </ion-button>
            </ion-buttons>
            <ion-title size="small">
                Preview: {{ selectedFormat === 'format1' ? 'Classic List' : 'Card Grid' }}
            </ion-title>
        </ion-toolbar>

        <div class="preview-container">
            @switch (selectedFormat) {
                @case ('format1') {
                    <incentive-format1 [incentives]="incentives"></incentive-format1>
                }
                @case ('format2') {
                    <incentive-format2 [incentives]="incentives"></incentive-format2>
                }
            }
        </div>
    }
</ion-content>